import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import SelfServeTripItineraryStopKeepOnSiteDialog from '@/components/SelfServeTripItineraryStopKeepOnSiteDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotItineraryStopKeepOnSite',
  props: {
  vehicleNeededEntireTrip: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ['vehicle-needed-entire-trip:update'],
  setup(__props, { emit }) {

const props = __props;





const isKeepOnSiteDialogOpen = ref<boolean>(false)


return { __sfc: true,props, emit, isKeepOnSiteDialogOpen, SelfServeTripItineraryStopKeepOnSiteDialog }
}

})